module.exports = __webpack_public_path__ + "img/logo-vertical-transparent-new.4a86f350.svg";